// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app" + "." + "151b12f0bc4856d14209" + ".css";
};